export const CALENDAR_STATUS_CONFIG = {
  PUBLISHED: {
    blocked: true,
    coverStyle: { backgroundColor: 'var(--color-error40)', color: 'var(--color-semantic-white)' },
  },
  DRAFT: {
    blocked: true,
    coverStyle: { backgroundColor: 'var(--color-error20)', color: 'var(--color-semantic-text)' },
  },
};

export const getPublishStatus = ({ isPublished, t }) => {
  const status = {
    true: { label: t('draftStatus.saved'), bg: '#E7F1FF', color: 'var(--color-primary50)' },
    false: { label: t('draftStatus.draft'), bg: '#F1F1F1', color: 'var(--color-semantic-text)' },
  };
  return status[isPublished];
};

export const getTalkingPointStatuses = ({ status, t }) => {
  const talkingPointStatus = {
    ACTIVE: { label: t('talkingPointStatuses.active'), bg: '#E9FFF2', color: 'var(--color-success60)' },
    INACTIVE: { label: t('talkingPointStatuses.inactive'), bg: '#F1F1F1', color: 'var(--color-semantic-text)' },
    FINISHED: { label: t('talkingPointStatuses.finished'), bg: '#F1F1F1', color: 'var(--color-semantic-text)' },
  };
  return talkingPointStatus[status];
};

export const getGiveawayStatutes = ({ status, t }) => {
  const giveawayStatus = {
    ACTIVE: { label: t('giveawayStatutes.active'), bg: '#E9FFF2', color: 'var(--color-success60)' },
    INACTIVE: { label: t('giveawayStatutes.inactive'), bg: '#F1F1F1', color: 'var(--color-semantic-text)' },
  };

  return giveawayStatus[status];
};
